import React, { memo } from 'react';
import Modal from 'react-modal';
import './styles.scss';

const ConfirmReminderModal = ({ handleSubmit, onClose }) => {
  return (
    <Modal
      isOpen
      id={'confirm-reminder-modal'}
      className="modal-default delete-initiation-modal"
      overlayClassName={'delete-initiation-modal-overlay'}
      onRequestClose={onClose}
      contentLabel="Example Modal"
      ariaHideApp={false}
    >
      <h2 className="modal-header">
        <div className={'title'}>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="5" y="5" width="38" height="38" rx="19" fill="#F4EBFF" />
            <rect x="5" y="5" width="38" height="38" rx="19" stroke="#F9F5FF" strokeWidth="10" />
            <path
              d="M25.1533 29.9987C25.0361 30.2008 24.8679 30.3685 24.6655 30.4851C24.4631 30.6016 24.2336 30.663 24 30.663C23.7664 30.663 23.5369 30.6016 23.3345 30.4851C23.1321 30.3685 22.9639 30.2008 22.8467 29.9987M28 21.332C28 20.2712 27.5786 19.2537 26.8284 18.5036C26.0783 17.7535 25.0609 17.332 24 17.332C22.9391 17.332 21.9217 17.7535 21.1716 18.5036C20.4214 19.2537 20 20.2712 20 21.332C20 25.9987 18 27.332 18 27.332H30C30 27.332 28 25.9987 28 21.332Z"
              stroke="#7F56D9"
              strokeWidth="1.67"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Please Confirm Action
        </div>
        <button className="btn btn-icon" onClick={onClose}>
          <i className="icon-icon-x" />
        </button>
      </h2>
      <div className="modal-body">
        <p className={'content'}>Are you sure you want to send reminders to fill out this form?</p>
      </div>
      <div className="modal-footer">
        <button className="btn btn-outline" onClick={onClose}>
          Cancel
        </button>
        <button className={'btn'} onClick={handleSubmit}>
          <span>Send</span>
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmReminderModal;
